import React from 'react';
import { useDispatch } from 'react-redux';
import { Colors, useGlobalStyles, useGlobalText } from 'utils';
import { Circle, DocumentTable, Line } from 'components';
import { httpRequestsOnLoadActions, httpRequestsOnSuccessActions, loadActions, LoadServices } from 'store';
import { createLoadStyle } from '../../createLoad/core';

const REQUEST_TYPE = 'ADD_GROUP_DOC';
const DELETE_REQUEST_TYPE = 'DELETE_GROUP_DOC';
const EDIT_REQUEST_TYPE = 'EDIT_REQUEST_TYPE';

export const GroupDocuments = ({ info, id }) => {
  const globalStyles = useGlobalStyles();
  const globalText = useGlobalText();
  const classes = createLoadStyle();
  const dispatch = useDispatch();


  const handleUpload = async (loadDoc) => {
    try {
      const currentFile = { ...loadDoc };
      currentFile.file.originalName = currentFile?.name;
      dispatch(httpRequestsOnSuccessActions.removeSuccess(REQUEST_TYPE));
      await LoadServices.UploadGroupDocument(id, currentFile);
      dispatch(httpRequestsOnSuccessActions.appendSuccess(REQUEST_TYPE));
      dispatch(loadActions.getGroupById(id, 'noLoad'));
      dispatch(httpRequestsOnLoadActions.removeLoading(REQUEST_TYPE));
    } catch (e) {
      dispatch(httpRequestsOnLoadActions.removeLoading(REQUEST_TYPE));
      dispatch(httpRequestsOnSuccessActions.removeSuccess(REQUEST_TYPE));
    }
  };

  const handleSetDocStatus = async (doc, type) => {
    try {
      dispatch(httpRequestsOnLoadActions.appendLoading(EDIT_REQUEST_TYPE));
      const sendInfo = {
        ...doc,
        status: type !== 'edit' ? doc.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE' : doc.status,
      };
      await LoadServices.EditGroupDocument(id, doc?.id, sendInfo);
      dispatch(httpRequestsOnLoadActions.removeLoading(EDIT_REQUEST_TYPE));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(EDIT_REQUEST_TYPE));
      dispatch(loadActions.getGroupById(id, 'noLoad'));
    } catch (e) {
      dispatch(httpRequestsOnLoadActions.removeLoading(EDIT_REQUEST_TYPE));
    }
  };

  const handleDelete = async (loadDoc) => {
    dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_REQUEST_TYPE))
    dispatch(httpRequestsOnLoadActions.appendLoading(DELETE_REQUEST_TYPE))
    try {
      const currentFile = { ...loadDoc };
      dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_REQUEST_TYPE));
      await LoadServices.DeleteGroupDocument(id, currentFile);
      dispatch(httpRequestsOnSuccessActions.appendSuccess(DELETE_REQUEST_TYPE))
      dispatch(loadActions.getGroupById(id, 'noLoad'));
      dispatch(httpRequestsOnLoadActions.removeLoading(REQUEST_TYPE));
    } catch (e) {
      dispatch(httpRequestsOnLoadActions.removeLoading(REQUEST_TYPE));
    }finally {
      dispatch(httpRequestsOnLoadActions.removeLoading(DELETE_REQUEST_TYPE))
      dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_REQUEST_TYPE));
    }
  }

  return (
    <div>
      <div className={classes.titleAndSwitcher}>
        <div className={globalStyles.centerItem}>
          <Circle number={4} back={Colors.ThemeAqua} />
          <p className={globalText.title}>
            Documents
          </p>
        </div>
      </div>
      <div className={globalStyles.flexAndFullWidth}>
        <div className={'MuiAccordionDetails-root'}>
          <Line height={'auto'} />
        </div>
        <div className={classes.documentSection}>
          <DocumentTable
            allDocs={info?.documents}
            handleChangeStatus={handleSetDocStatus}
            changeStatusAction={EDIT_REQUEST_TYPE}
            deleteDocAction={DELETE_REQUEST_TYPE}
            handleDeleteDocument={handleDelete}
            addLoadAction={REQUEST_TYPE}
            handleUploadFile={handleUpload}
          />
        </div>
      </div>
    </div>
  );
};